import _definePage_default_0 from '/app/src/pages/index.vue?definePage&vue&lang.tsx'
import { _mergeRouteRecord } from 'unplugin-vue-router/runtime'
import _definePage_default_2 from '/app/src/pages/children.vue?definePage&vue&lang.tsx'
import _definePage_default_3 from '/app/src/pages/dashboard.vue?definePage&vue&lang.tsx'
import _definePage_dealer_4 from '/app/src/pages/dashboard@dealer.vue?definePage&vue&lang.tsx'
import _definePage_default_5 from '/app/src/pages/dealers.vue?definePage&vue&lang.tsx'
import _definePage_default_6 from '/app/src/pages/dealers.[id].vue?definePage&vue&lang.tsx'
import _definePage_default_7 from '/app/src/pages/devices.vue?definePage&vue&lang.tsx'
import _definePage_default_8 from '/app/src/pages/families.vue?definePage&vue&lang.tsx'
import _definePage_default_9 from '/app/src/pages/family.[id].vue?definePage&vue&lang.tsx'
import _definePage_default_10 from '/app/src/pages/licenses.vue?definePage&vue&lang.tsx'
import _definePage_fullscreen_11 from '/app/src/pages/login@fullscreen.vue?definePage&vue&lang.tsx'
import _definePage_default_12 from '/app/src/pages/regions.vue?definePage&vue&lang.tsx'
import _definePage_default_13 from '/app/src/pages/regions.[id].vue?definePage&vue&lang.tsx'
import _definePage_default_14 from '/app/src/pages/roles.vue?definePage&vue&lang.tsx'
import _definePage_default_15 from '/app/src/pages/service-types.vue?definePage&vue&lang.tsx'
import _definePage_default_16 from '/app/src/pages/services.vue?definePage&vue&lang.tsx'
import _definePage_default_17 from '/app/src/pages/settings.vue?definePage&vue&lang.tsx'
import _definePage_default_18 from '/app/src/pages/users.vue?definePage&vue&lang.tsx'

export const routes = [
  _mergeRouteRecord(
    {
      path: '/',
      name: '/',
      component: () => import('/app/src/pages/index.vue'),
      /* no children */
    },
    _definePage_default_0
  ),
  _mergeRouteRecord(
    {
      path: '/children',
      name: '/children',
      component: () => import('/app/src/pages/children.vue'),
      /* no children */
    },
    _definePage_default_2
  ),
  _mergeRouteRecord(
    {
      path: '/dashboard',
      name: '/dashboard',
      components: {
        'default': () => import('/app/src/pages/dashboard.vue'),
        'dealer': () => import('/app/src/pages/dashboard@dealer.vue')
      },
      /* no children */
    },
    _definePage_default_3,
    _definePage_dealer_4
  ),
  _mergeRouteRecord(
    {
      path: '/dealers',
      name: '/dealers',
      component: () => import('/app/src/pages/dealers.vue'),
      /* no children */
    },
    _definePage_default_5
  ),
  _mergeRouteRecord(
    {
      path: '/dealers/:id',
      name: '/dealers.[id]',
      component: () => import('/app/src/pages/dealers.[id].vue'),
      /* no children */
    },
    _definePage_default_6
  ),
  _mergeRouteRecord(
    {
      path: '/devices',
      name: '/devices',
      component: () => import('/app/src/pages/devices.vue'),
      /* no children */
    },
    _definePage_default_7
  ),
  _mergeRouteRecord(
    {
      path: '/families',
      name: '/families',
      component: () => import('/app/src/pages/families.vue'),
      /* no children */
    },
    _definePage_default_8
  ),
  _mergeRouteRecord(
    {
      path: '/family/:id',
      name: '/family.[id]',
      component: () => import('/app/src/pages/family.[id].vue'),
      /* no children */
    },
    _definePage_default_9
  ),
  _mergeRouteRecord(
    {
      path: '/licenses',
      name: '/licenses',
      component: () => import('/app/src/pages/licenses.vue'),
      /* no children */
    },
    _definePage_default_10
  ),
  _mergeRouteRecord(
    {
      path: '/login',
      name: '/login',
      components: {
        'fullscreen': () => import('/app/src/pages/login@fullscreen.vue')
      },
      /* no children */
    },
    _definePage_fullscreen_11
  ),
  _mergeRouteRecord(
    {
      path: '/regions',
      name: '/regions',
      component: () => import('/app/src/pages/regions.vue'),
      /* no children */
    },
    _definePage_default_12
  ),
  _mergeRouteRecord(
    {
      path: '/regions/:id',
      name: '/regions.[id]',
      component: () => import('/app/src/pages/regions.[id].vue'),
      /* no children */
    },
    _definePage_default_13
  ),
  _mergeRouteRecord(
    {
      path: '/roles',
      name: '/roles',
      component: () => import('/app/src/pages/roles.vue'),
      /* no children */
    },
    _definePage_default_14
  ),
  _mergeRouteRecord(
    {
      path: '/service-types',
      name: '/service-types',
      component: () => import('/app/src/pages/service-types.vue'),
      /* no children */
    },
    _definePage_default_15
  ),
  _mergeRouteRecord(
    {
      path: '/services',
      name: '/services',
      component: () => import('/app/src/pages/services.vue'),
      /* no children */
    },
    _definePage_default_16
  ),
  _mergeRouteRecord(
    {
      path: '/settings',
      name: '/settings',
      component: () => import('/app/src/pages/settings.vue'),
      /* no children */
    },
    _definePage_default_17
  ),
  _mergeRouteRecord(
    {
      path: '/users',
      name: '/users',
      component: () => import('/app/src/pages/users.vue'),
      /* no children */
    },
    _definePage_default_18
  )
]

export function handleHotUpdate(_router, _hotUpdateCallback) {
  if (import.meta.hot) {
    import.meta.hot.data.router = _router
    import.meta.hot.data.router_hotUpdateCallback = _hotUpdateCallback
  }
}

if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[unplugin-vue-router:HMR] Cannot replace the routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.routes) {
      router.addRoute(route)
    }
    // call the hotUpdateCallback for custom updates
    import.meta.hot.data.router_hotUpdateCallback?.(mod.routes)
    const route = router.currentRoute.value
    router.replace({
      ...route,
      // NOTE: we should be able to just do ...route but the router
      // currently skips resolving and can give errors with renamed routes
      // so we explicitly set remove matched and name
      name: undefined,
      matched: undefined,
      force: true
    })
  })
}

